const menus = [
  {
    id: 1,
    tomenu: '#about',
    namemenu: 'About',
  },
  {
    id: 2,
    tomenu: '#services',
    namemenu: 'Specialization',
  },
  {
    id: 3,
    tomenu: '#portfolio',
    namemenu: 'Projects',
  },
  // {
  //   id: 4,
  //   tomenu: '#testimonial',
  //   namemenu: 'Testimonial',
  // },
  {
    id: 5,
    tomenu: '#contact',
    namemenu: 'Contact',
  },
];

export default menus;
